import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { SgAuxRouteBridgeService, SgAuxRouteBridgeOutletDirective } from '@sg/ui-kit/aux-route-bridge';
import { MatDrawerContainer, MatDrawer } from '@angular/material/sidenav';

@Directive({
  selector: 'mat-drawer[sgMatDrawerAuxRouteBridgeOutlet]',
  standalone: false,
})
export class MatDrawerAuxRouteOutletDirective extends SgAuxRouteBridgeOutletDirective {
  constructor(
    bridgeService: SgAuxRouteBridgeService,
    private elRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    public matDrawerContainer: MatDrawerContainer,
    public matDrawer: MatDrawer
  ) {
    super(bridgeService);
  }

  @Input('sgMatDrawerAuxRouteBridgeOutlet') declare name: string;

  setWidth(width: string): void {
    this.renderer.setStyle(this.elRef.nativeElement, 'width', width);
  }

  auxBeforeDestroyView(): void {
    this.renderer.setStyle(this.elRef.nativeElement, 'width', '');
  }
}
